export enum ListViewDefinitionType {
    Primary,
    Default,
    Boolean,
    DateTime,
    Date,
    Time,
    TimeAgo,
}
